import { CountryCode, isValidPhoneNumber } from 'libphonenumber-js';

const validatePhoneNumber = (phoneNumber: string, countryCode?: CountryCode): boolean => isValidPhoneNumber(
	phoneNumber, countryCode,
);

export default validatePhoneNumber;
